import { Component, Input, OnChanges } from '@angular/core';
import { TableData } from '../../services/chat-stream-event.model';
import { formatCellValue, isNumericColumn } from './format-cell';

@Component({
  selector: 'gung-glippy-table',
  standalone: false,
  templateUrl: './glippy-table.component.html',
  styleUrl: './glippy-table.component.scss'
})
export class GlippyTableComponent implements OnChanges {
  @Input() data!: TableData;

  numericColumns = new Set<string>();
  formatCell = formatCellValue;

  ngOnChanges(): void {
    this.numericColumns = new Set(
      this.data.columns.filter(c => isNumericColumn(this.data.rows, c.key)).map(c => c.key)
    );
  }
}
